module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('vue-draggable-resizable', {
    key: _vm.handler,
    staticClass: "ql-position-cue-marker",
    style: ({
      color: _vm.cueColor(_vm.cue),
      transform: _vm.transformStyle(),
      '--cue-bgColor': _vm.cueColor(_vm.cue)
    }),
    attrs: {
      "handles": [],
      "x": _vm.cuePosLeft,
      "y": _vm.cuePosTop,
      "w": _vm.cuePosWidth,
      "h": _vm.cuePosHeight,
      "minw": 2,
      "minh": 2,
      "parent": true,
      "draggable": _vm.editable && !_vm.locked
    },
    on: {
      "dragging": _vm.onDrag,
      "dragstop": _vm.onDragStop,
      "activated": _vm.onActivate,
      "deactivated": _vm.onDeactivate
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-08c49614","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/print/cues/cue-position-marker.vue
// module id = 1200
// module chunks = 21